/**
 * Shared utility — flags a conversation with confirmed agencies and returns the incident number.
 * Used by AgencyAgent (normal flow) and ImageUploadAgent (crisis fast-track).
 */

import { config } from '../../config/runtime-config';

const BACKEND_URL = config.REACT_APP_BACKEND_URL;

async function flagConversation_impl(convId: string, agencies: string[]): Promise<string | null> {
  if (!BACKEND_URL) {
    console.warn('[flagConversation] No BACKEND_URL — cannot save agency tags');
    return null;
  }
  try {
    const res = await fetch(`${BACKEND_URL}/api/conversations/${convId}/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ agencies }),
    });
    if (!res.ok) {
      console.warn('[flagConversation] POST /conversations/update failed:', res.status);
      return null;
    }
    const data = await res.json();
    const incidentNumber: string | null = data.incident_number || null;
    console.log('[flagConversation] Agency tags saved:', agencies, '| Incident #:', incidentNumber);
    if (incidentNumber) {
      localStorage.setItem('dp_incident_number', incidentNumber);
    }
    return incidentNumber;
  } catch (err) {
    console.warn('[flagConversation] Failed to flag conversation:', err);
    return null;
  }
}

export async function flagConversation(agencies: string[]): Promise<string | null> {
  const convId = localStorage.getItem('dp_conversation_id');
  if (!convId) {
    console.warn('[flagConversation] No conversation_id in localStorage — retrying in 2s...');
    await new Promise(r => setTimeout(r, 2000));
    const retryConvId = localStorage.getItem('dp_conversation_id');
    if (!retryConvId) {
      console.error('[flagConversation] Still no conversation_id — agency tags will not be saved');
      return null;
    }
    return flagConversation_impl(retryConvId, agencies);
  }
  return flagConversation_impl(convId, agencies);
}
